import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IncidentTabsDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-incident-tabs',
  templateUrl: './incident-tabs.component.html',
  styleUrls: ['./incident-tabs.component.scss']
})
export class IncidentTabsComponent  implements OnChanges {

  incidentTabsForm: FormGroup;
  incidentTabsFormArray: FormGroup;
  control = new FormControl();
  @Input() incidentTabss: IncidentTabsDto[];
  @Input() routeAnimationsElements: any;
  @Output() incidentTabs = new EventEmitter<IncidentTabsDto[]>()
  @Output() deleteIncidentTabsEvent = new EventEmitter<any>()

    selectedIncidentTabs: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createIncidentTabsForm();
    }

    createIncidentTabsForm() {
      this.incidentTabsForm = this.fb.group({
        TabName: ['', Validators.required],
        TabDescription:[''],
        TabInstructions: [''],
        id: null
        });
        this.incidentTabsFormArray = this.fb.group({ IncidentTabss: this.fb.array([])
          });
        this.setIncidentTabs();
    }

  // method to display IncidentTabs
  setIncidentTabs() {
    const control  = this.incidentTabsFormArray.controls.IncidentTabss as FormArray;
    this.incidentTabss.forEach( e => {
      control.push(
        this.fb.group({
          TabName: e.TabName,
          TabDescription: e.TabDescription,
          TabInstructions: e.TabInstructions,
          id: e.id
        })
      );
    });
  }


  // method to add IncidentTabs
  addIncidentTabs(value: IncidentTabsDto) {
    const control  = this.incidentTabsFormArray.controls.IncidentTabss as FormArray;
    control.insert(0,
          this.fb.group({
            TabName: value.TabName,
            TabDescription: value.TabDescription,
            TabInstructions: value.TabInstructions,
            id: null
          })
       );
  }

  selectIncidentTabs(value) {
    
  }

  // method to delete IncidentTabs from arrary list
  deleteIncidentTabs(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.incidentTabsFormArray.controls.IncidentTabss as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.incidentTabss.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.incidentTabss[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: IncidentTabsDto) {
    if(this.incidentTabsForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.incidentTabsFormArray.get('IncidentTabss')['controls'][this.selectedIndex].patchValue({...formValue});
    } else {
      this.addIncidentTabs(formValue);
    }
    this.selectedIndex = null;
    this.incidentTabsForm.reset()
  }

 
  onEdit(index, value: IncidentTabsDto) {
    this.selectedIndex = index;
    this.incidentTabsForm.patchValue({...value});
  }
  onClearForm() {
    this.selectedIndex = null;
    this.incidentTabsForm.reset();
  }

  onSubmit(formValue: IncidentTabsDto[]) {
  this.incidentTabs.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteIncidentTabsEvent.emit(this.filteredDelete);
  }
  }

  
  }








